// @ts-ignore
import dateFormat, { i18n } from 'dateformat';
import { RenderParamType } from '@base/lib/Countdown';
import { getCookie } from 'ava-util/dist/cookie';
import { COOKIE_LANG } from 'base/config/constant';

export enum TimeFormat {
    DAY = 'yyyy.mm.dd',
    MINUTE = 'yyyy.mm.dd HH:MM',
    SECOND = 'mmm dd, yyyy HH:MM:ss',
}

const i18nNames = {
    en: {
        dayNames: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat',
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
        ],
        monthNames: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ],
        timeNames: ['a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'],
    },
    de: {
        dayNames: [
            'So',
            'Mo',
            'Di',
            'Mi',
            'Do',
            'Fr',
            'Sa',
            'Sonntag',
            'Montag',
            'Dienstag',
            'Mittwoch',
            'Donnerstag',
            'Freitag',
            'Samstag',
        ],
        monthNames: [
            'Jan',
            'Feb',
            'März',
            'Apr',
            'Mai',
            'Juni',
            'Juli',
            'Aug',
            'Sept',
            'Okt',
            'Nov',
            'Dez',
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember',
        ],
        timeNames: ['a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'],
    },
};

function setDateFormatI18n() {
    const lang = getCookie(COOKIE_LANG) || 'en';
    const names = i18nNames[lang];
    i18n.dayNames = names.dayNames;
    i18n.monthNames = names.monthNames;
    i18n.timeNames = names.timeNames;
}

/**
 * @param utcTime 时间戳应为 毫秒级别
 * @param formater
 */
export function transLocalTime(utcTime: string | number, formater: string = TimeFormat.SECOND): string {
    setDateFormatI18n();
    return dateFormat(new Date(utcTime), formater)
}

// getTimeStamp('2023-12-16 23:59:59')，参数传入北京时间
export function getTimeStamp(time?: string): number {
    if (time) {
        return Math.round((new Date(time).getTime()) / 1000);
    }
    return Math.round((new Date().getTime()) / 1000)
}

// getUTCTimeStamp('2023-12-16 23:59:59'), 参数传入 utc 时间
export function getUTCTimeStamp(utcDate: string): number {
    const localTime = new Date(utcDate).getTime();
    const timeOffset = new Date().getTimezoneOffset() * 60000;
    return Math.round((localTime - timeOffset) / 1000)
}

export function getOffsetTimeStamp(offsetDays: number): number {
    var d = new Date();
    d.setDate(d.getDate() + offsetDays);
    return Math.round((d.getTime()) / 1000)
}

/**
 * 获取当前日期的前几天或者后几天
 * @param from 开始日期，0表示今天，-1表示昨天，1表示明天，以此类推
 * @param range 取多少天
 */
export function getRangeDates(from: number, range: number): string[] {
    return new Array(range).fill(void 0).map((_, i) => {
        var d = new Date();
        d.setDate(d.getDate() + from + i);
        return dateFormat(d, 'yyyy-mm-dd')
    })
}

export function renderDHMSCountdown(o: RenderParamType) {
    let arr: string[] = [];
    if (Number(o.day) > 0) {
        arr.push(`${o.day}D`);
    }
    arr.push(`${o.hour}H`);
    arr.push(`${o.minute}M`);
    arr.push(`${o.second}S`);

    return arr.map(item => `<span>${item}</span>`).join('<em>:</em>')
}

const periodConfig = {
    '420': {
        start: '2024-04-15 07:00:00',
        end: '2024-04-23 07:00:00',
    }
}

export function checkPeriod(key: string): boolean {
    const config = periodConfig[key];
    if (!config) {
        return false;
    }
    const start = getUTCTimeStamp(config.start);
    const end = getUTCTimeStamp(config.end);
    const now = getTimeStamp();
    return now >= start && now <= end;
}

export function checkPeriodActive(start: number, end: number): boolean {
    const now = getTimeStamp();
    return now >= Number(start) && now <= Number(end);
}